import { EventEmitter } from '../../Shared/EventEmitter';
import { getDefaultZoomUI } from '../lib/zoomUI';
import { completeObject } from '../../Shared/complete';
const globalThemeEvent = new EventEmitter();
let cacheGlobalThemeMode = 'light';
let cacheGlobalZoomUI = getDefaultZoomUI();
globalThemeEvent.on('updateThemeMode', (mode) => {
    cacheGlobalThemeMode = mode;
});
globalThemeEvent.on('defineLocale', (map) => {
    cacheGlobalZoomUI.localeMap = {
        ...(cacheGlobalZoomUI.localeMap ?? {}),
        ...map,
    };
});
globalThemeEvent.on('updateLocaleKey', (key) => {
    cacheGlobalZoomUI.localeKey = key;
});
globalThemeEvent.on('updateZoomUI', (zoomUI) => {
    cacheGlobalZoomUI = completeObject(zoomUI, cacheGlobalZoomUI);
});
globalThemeEvent.on('resetZoomUI', () => {
    cacheGlobalZoomUI = getDefaultZoomUI();
});
export { globalThemeEvent };
export function updateGlobalThemeMode(mode) {
    globalThemeEvent.emit('updateThemeMode', mode);
}
export function getGlobalThemeMode() {
    return cacheGlobalThemeMode;
}
export function switchGlobalThemeMode() {
    if (cacheGlobalThemeMode === 'light') {
        updateGlobalThemeMode('dark');
    }
    else {
        updateGlobalThemeMode('light');
    }
}
export function defineGlobalLocale(map) {
    globalThemeEvent.emit('defineLocale', map);
}
export function updateGlobalLocaleKey(key) {
    globalThemeEvent.emit('updateLocaleKey', key);
}
// export function getGlobalLocaleKey(): ZoomLocaleKey {
//   return cacheGlobalZoomUI.localeKey;
// }
export function updateGlobalZoomUI(zoomUI) {
    globalThemeEvent.emit('updateZoomUI', zoomUI);
}
export function getGlobalZoomUI() {
    return cacheGlobalZoomUI;
}
export function resetGlobalZoomUI() {
    globalThemeEvent.emit('resetZoomUI');
}
